/** Settings fields fill the side panel rather than a fixed page column. */
export const SETTINGS_FIELD_WIDTH = '100%';
/** Legacy search param of the removed full-page settings route. */
export const SETTINGS_SECTION_SEARCH_PARAM = 'section';
/** Search param that opens the settings side panel on any builder section. */
export const WORKFLOW_SETTINGS_SEARCH_PARAM = 'settings';
/** Search param value for an open panel with every section collapsed. */
export const SETTINGS_COLLAPSED_KEY = 'open';
/** Search param value that opens the standalone access panel. */
export const ACCESS_PANEL_KEY = 'access';
/** Search param value that opens the standalone document templates panel. */
export const DOCUMENTS_PANEL_KEY = 'documents';
/** Search param value that opens the standalone workflow signers panel. */
export const SIGNERS_PANEL_KEY = 'signers';
/** Legacy settings section now handled by the standalone access panel. */
export const LEGACY_WORKFLOW_ACCESS_SECTION = 'workflow-access';

export const REQUEST_NAME_EXPRESSION_ID =
  'workflow-settings-request-name-format';
export const ARCHIVE_SUBFOLDER_EXPRESSION_ID =
  'workflow-settings-archive-subfolder-format';
export const DOCUMENT_NAME_EXPRESSION_ID =
  'workflow-settings-document-name-format';

export const settingsSectionKeys = [
  'general',
  'naming',
  'archive',
  'notifications',
  'routing',
] as const;

export type SettingsSectionKey = (typeof settingsSectionKeys)[number];

export const workflowUtilityPanelKeys = [
  ...settingsSectionKeys,
  SETTINGS_COLLAPSED_KEY,
  ACCESS_PANEL_KEY,
  DOCUMENTS_PANEL_KEY,
  SIGNERS_PANEL_KEY,
  LEGACY_WORKFLOW_ACCESS_SECTION,
] as const;

/** Section expanded when the panel is opened from the utility rail. */
export const DEFAULT_SETTINGS_SECTION: SettingsSectionKey = 'general';
